(function()
{
    //Import classes
    var BasePanel = include('springroll.easeljs.BasePanel'),
        Bitmap = include('createjs.Bitmap'),
        AccButton = include('WGBH.AccButton');

    /**
     * Panel contains all of the visual elements for the title state
     * @class WGBH.TitlePanel
     * @extends springroll.easeljs.BasePanel
     */
    var TitlePanel = function()
    {
        BasePanel.call(this);
    };

    //Super prototype
    var s = BasePanel.prototype;

    //Extend the base panel
    var p = extend(TitlePanel, BasePanel);

    /**
     * Setup the state, this happens on each state entering
     */
    p.setup = function()
    {
		// set canvas bg color
		app.cvstage.setAttribute('style',
		'background-color:' + app.config.COLORS.TITLEBG);
		app.cvstage.style['background-color'] = app.config.COLORS.TITLEBG;
		
		// add other elements
        this.titlecard = new Bitmap(images.TitleCard);
        this.titlecard.x = app.config.GAME.TITLE.card.x;
        this.titlecard.y = app.config.GAME.TITLE.card.y;
        this.titleframe = new Bitmap(images.title_frame);
        this.titleframe.x = app.config.GAME.FRAME.x;
        this.titleframe.y = app.config.GAME.FRAME.y;
        this.playbt = new AccButton(
        				'playbt', 
        				LOADED_OBJECTS.sprsheets.graphics_spr,
        				'_playbt_on',
        				app.config.GAME.TITLE.playbt.x,
        				app.config.GAME.TITLE.playbt.y, 
        				app.config.GAME.TITLE.playbt.wid, 
        				app.config.GAME.TITLE.playbt.hgt,
        				app.config.GAME.TITLE.playbt.label,
        				true
        				);
		this.addChild(this.titlecard);
		this.addChild(this.titleframe);
		this.addChild(this.playbt.view);
    };

    /**
     * Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
        s.teardown.call(this);
        this.titlecard = null;
        this.titleframe = null;
        this.playbt = null;
    };

    //Assign to namespace
    namespace('WGBH').TitlePanel = TitlePanel;
}());